
import { Directive, ElementRef, HostListener, inject, input, DOCUMENT } from '@angular/core';
import { UrlEventTypes } from '../models/url-event.model';
import { GTMService } from '../services/gtm.service';

type LinkHTMLElement = HTMLButtonElement & { link?: string };

@Directive({
  selector: '[gtmLinkClick]',
  standalone: true,
})
export class GtmLinkClickDirective {
  private readonly el = inject(ElementRef<HTMLElement>);
  private readonly gtmService = inject(GTMService);
  private readonly document: Document = inject(DOCUMENT);

  gtmLinkClick = input.required<UrlEventTypes>();
  gtmText = input<string>();
  gtmUrl = input<string>();

  private getElementText(element: HTMLElement): string {
    const text = element.textContent?.trim() ?? '';

    if (text === '') {
      console.warn('GtmClickDirective does not find text in the element', element);
    }

    return text;
  }

  private buildFullUrl(path: string | undefined | null): string {
    if (path == null || path === '') {
      return '';
    }

    const baseUrl = this.document.baseURI;
    return new URL(path, baseUrl).href;
  }

  private getElementUrl(element: HTMLElement): string {
    if (element instanceof HTMLAnchorElement) {
      const url = element.href ?? '';

      if (url === '') {
        console.warn('GtmClickDirective does not find url in the element', element);
      }

      return url;
    }

    const linkElement = element as LinkHTMLElement;

    if (linkElement instanceof HTMLButtonElement) {
      const routerLink = linkElement?.link ?? linkElement.getAttribute('ng-reflect-router-link');
      const url = this.buildFullUrl(routerLink);

      if (url === '') {
        console.warn('GtmClickDirective does not find url in the element', element);
      }

      return url;
    }

    console.warn('GtmClickDirective does not find url in the element', element);
    return '';
  }

  @HostListener('click')
  onClick(): void {
    const element = this.el.nativeElement;
    const text = this.gtmText() ?? this.getElementText(element);
    const url = this.gtmUrl() ?? this.getElementUrl(element);

    if (url !== '' && text !== '') {
      this.gtmService.urlClickEvent(this.gtmLinkClick(), text, url);
    }
  }
}
